import React, { useState, useEffect } from 'react';
import useTranslate from '../../../../Hooks/useTranslate';
import { Box } from '@mui/material';
import ReportSectionWrapper from './ReportSectionWrapper';
import RoundedTabs from '../../../../Components/Tabs';
import { culture } from '../../../../Helpers/dates';
import capitalize from '../../../../Helpers/StringsFormatting/capitalize';

const getWavePeriodLabel = (wavePeriod) => {
  if (!wavePeriod) return '';
  const year = wavePeriod.slice(0, 4);
  const month = wavePeriod.slice(4);
  const date = new Date(year, month - 1);
  return capitalize(
    date.toLocaleString(culture, { month: 'long', year: 'numeric' })
  );
};

const GraphsWrapper = function GraphsWrapper({
  graphData,
  wavePeriod,
  branchDescription,
}) {
  const translate = useTranslate();

  const [targetTabValue, setTargetTabValue] = useState(0);
  const [notTargetTabValue, setNotTargetTabValue] = useState(0);

  useEffect(() => {
    setTargetTabValue(0);
    setNotTargetTabValue(0);
  }, [graphData]);

  const handleTabChange = (event, newValue) => {
    setTargetTabValue(newValue);
  };

  const handleNotTargetTabChange = (event, newValue) => {
    setNotTargetTabValue(newValue);
  };

  const targetCounters = graphData?.targetCounters ?? [];
  const notTargetCounters = graphData?.notTargetCounters ?? [];

  const wavePeriodLabel = getWavePeriodLabel(wavePeriod);
  return (
    <>
      <ReportSectionWrapper
        data={graphData}
        title="TOTAL"
        branchDescription={branchDescription ?? 'N/A'}
        wavePeriod={wavePeriodLabel ?? ''}
        isTotal
      />
      <Box sx={{ width: '90%' }}>
        <RoundedTabs
          textColor="#fff"
          value={targetTabValue}
          onChange={handleTabChange}
          tabs={targetCounters?.map(({ sectionName }, index) => ({
            value: index,
            label: translate(sectionName),
          }))}
          fullWidth
        />
      </Box>
      <ReportSectionWrapper
        key={`target-${targetTabValue}`}
        data={targetCounters[targetTabValue]}
        title={targetCounters[targetTabValue]?.sectionName ?? 'TOTAL'}
        branchDescription={branchDescription ?? 'N/A'}
        wavePeriod={wavePeriodLabel ?? ''}
      />
      <Box sx={{ width: '90%' }}>
        <RoundedTabs
          value={notTargetTabValue}
          onChange={handleNotTargetTabChange}
          tabs={notTargetCounters?.map(({ sectionName }, index) => ({
            value: index,
            label: translate(sectionName),
          }))}
          textColor="#fff"
          fullWidth
        />
      </Box>
      <ReportSectionWrapper
        key={`not-target-${notTargetTabValue}`}
        data={notTargetCounters[notTargetTabValue]}
        title={notTargetCounters[notTargetTabValue]?.sectionName ?? 'TOTAL'}
        branchDescription={branchDescription ?? 'N/A'}
        wavePeriod={wavePeriodLabel ?? ''}
      />
    </>
  );
};

export default GraphsWrapper;
